export default "__VITE_ASSET__a651aebc__"